import React from 'react';

export const name = 'flag-PT';

export const FlagPT = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_377)">
      <mask
        id="mask0_2_377"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_377)">
        <path
          d="M0 12C0.000299071 14.4501 0.750567 16.8414 2.14997 18.8525C3.54938 20.8636 5.53088 22.3982 7.82812 23.25L8.86875 12L7.82812 0.75C5.53088 1.60179 3.54938 3.13636 2.14997 5.14748C0.750567 7.15861 0.000299071 9.54989 0 12Z"
          fill="#6DA544"
        />
        <path
          d="M24 12C23.9998 10.0649 23.5315 8.15855 22.6353 6.44353C21.739 4.72852 20.4413 3.25567 18.8528 2.15061C17.2642 1.04554 15.432 0.34103 13.5124 0.0971498C11.5927 -0.14673 9.64252 0.0772536 7.82812 0.750005V23.25C9.64252 23.9228 11.5927 24.1467 13.5124 23.9029C15.432 23.659 17.2642 22.9545 18.8528 21.8494C20.4413 20.7443 21.739 19.2715 22.6353 17.5565C23.5315 15.8415 23.9998 13.9351 24 12Z"
          fill="#D80027"
        />
        <path
          d="M7.82812 16.1719C10.1322 16.1719 12 14.304 12 12C12 9.69595 10.1322 7.82812 7.82812 7.82812C5.52408 7.82812 3.65625 9.69595 3.65625 12C3.65625 14.304 5.52408 16.1719 7.82812 16.1719Z"
          fill="#FFDA44"
        />
        <path
          d="M5.47969 9.91405V12.5156C5.47969 13.1378 5.72686 13.7346 6.16683 14.1746C6.6068 14.6145 7.20357 14.8617 7.82578 14.8617C8.448 14.8617 9.04472 14.6145 9.48474 14.1746C9.92471 13.7346 10.1719 13.1378 10.1719 12.5156V9.90936H5.48438L5.47969 9.91405Z"
          fill="#D80027"
        />
        <path
          d="M7.82812 13.3031C7.39687 13.3031 7.04531 12.9516 7.04531 12.5203V11.4844H8.61094V12.5156C8.61094 12.9469 8.25937 13.2984 7.82812 13.2984V13.3031Z"
          fill="#EEEEEE"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_377">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
